import * as React from 'react';
const GoogleIcon = (props) => (
  <svg
    width={20.625}
    height={20}
    viewBox="0 0 20.625 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.112 10.209q-.002-.975-.167-1.875h-8.632v3.55h4.933a4.22 4.22 0 0 1-1.841 2.758v2.308h2.975c1.733-1.6 2.733-3.95 2.733-6.741"
      fill="#4285F4"
    />
    <path
      d="M10.313 19.167c2.475 0 4.55-.817 6.066-2.217l-2.975-2.308c-.816.55-1.858.883-3.091.883-2.384 0-4.409-1.608-5.134-3.775h-3.05v2.367c1.509 2.992 4.6 5.05 8.184 5.05"
      fill="#34A853"
    />
    <path
      d="M5.179 11.742A5.5 5.5 0 0 1 4.888 10c0-.608.108-1.192.292-1.742V5.892H2.13C1.505 7.125 1.146 8.517 1.146 10s.359 2.875.984 4.108l2.375-1.85z"
      fill="#FBBC05"
    />
    <path
      d="M10.313 4.484c1.35 0 2.55.466 3.508 1.366l2.625-2.625C14.854 1.742 12.788.833 10.313.833c-3.584 0-6.675 2.059-8.184 5.059l3.05 2.367c.725-2.167 2.75-3.775 5.134-3.775"
      fill="#EA4335"
    />
  </svg>
);
export default GoogleIcon;
